var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_vm._l((_vm.sortedCurrentNavItems),function(item,index){return [_c(item.component,{key:("nav-" + index),tag:"component"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }